import { useEffect } from 'react';
import { isScrollbarClick } from '../Utils/scrollbarUtils';

/**
 * Stops scrollbar clicks from reaching the click-outside handlers that close popups.
 *
 * Those handlers (react-datetime's bundled react-onclickoutside, ComboBox's useOutsideClick,
 * AdvancedAdjustmentPopover) all listen for `mousedown` on `document` in the bubble phase, so a
 * capture-phase listener on `document` runs first and can stop the event before they see it.
 * `stopPropagation` does not preventDefault, so dragging the scrollbar still scrolls as normal.
 *
 * Mount once, at the app root.
 */
const useScrollbarClickGuard = (): void => {
    useEffect(() => {
        const handleMouseDown = (event: MouseEvent): void => {
            if (isScrollbarClick(event)) event.stopPropagation();
        };

        document.addEventListener('mousedown', handleMouseDown, { capture: true });

        return () => {
            document.removeEventListener('mousedown', handleMouseDown, { capture: true });
        };
    }, []);
};

export default useScrollbarClickGuard;
